import { Box, Button, Text, Tooltip, Image, VStack, HStack } from '@chakra-ui/react';
import { Icon } from '@blueprintjs/core';
import { Switch, Route, useRouteMatch, useHistory, Redirect } from 'react-router-dom';
import { MapSettings } from '../MapSettings';
import { MapSearch } from '../MapSearch';
import { ZeroState } from '../ZeroState';
import { useContext } from 'react';
import MapContext from '../../context/MapContext';
import { RouteEditor } from '../RouteEditor';
import useIsDemo from '../../hooks/useIsDemo';
import useIsChartCoverageDemo from '../../hooks/useIsChartCoverageDemo';
import UIContext from '../../context/UIContext';

const landingPageUrl = import.meta.env.VITE_LANDING_PAGE_URL;

function SidebarButton({ title, icon, path }) {
    const history = useHistory();
    const isActive = useRouteMatch({
        path: path,
    });
    const {isIosApp} = useContext(UIContext);
    return (
        <Box>
            <Tooltip placement="right" label={<Text>{title}</Text>}>
                <Button
                    _hover={!isIosApp && {
                        bg: isActive ? '#2b91f0' : '#439ff5',
                        color: 'white',
                    }}
                    bg={isActive ? '#2280d8' : 'transparent'}
                    w="40px"
                    h="40px"
                    onClick={() => {
                        if (isActive) {
                            history.push('/' + history.location.search);
                        } else {
                            history.push(path + history.location.search);
                        }
                    }}
                    color={isActive ? 'white' : 'rgba(0,0,0,0.8)'}
                >
                    <Text mb="0px">
                        <Icon icon={icon} size="16" />
                    </Text>
                </Button>
            </Tooltip>
        </Box>
    );
}

export function Sidebar() {
    const isDefaultRoute = useRouteMatch({
        path: '/',
        exact: true,
    });
    const history = useHistory();
    const sidebarOpen = !isDefaultRoute;
    const { markers, mapRef } = useContext(MapContext);
    const isDemo = useIsDemo();
    const isChartCoverageDemo = useIsChartCoverageDemo();
    const { isIosApp, insets } = useContext(UIContext);

    if (isDemo || isChartCoverageDemo) {
        return null;
    }

    let topVal = sidebarOpen ? '0px' : '10px';
    if (isIosApp) {
        topVal = sidebarOpen ? '0px' : insets.top;
    }

    return (
        <>
            {/* <Box bg="white" zIndex="1" display="flex" flexDir="row" position="relative">
                <Box flex="0 0 auto" w="40px" borderRight={sidebarOpen && '1px solid rgba(0,0,0,0.2)'}>
                    <SidebarButton title="Map" icon="map" path="/map" />
                    <SidebarButton title="Search" icon="search" path="/search" />
                    <SidebarButton title="Routes" icon="route" path="/routes" />
                    <SidebarButton title="Destinations" icon="unpin" path="/destinations" />
                    <SidebarButton title="Past Tracks" icon="anchor" path="/past-tracks" />
                </Box>
            </Box> */}

            <Box
                bg={sidebarOpen ? 'rgba(250,250,250,0.9)' : 'rgba(255,255,255,1.0)'}
                zIndex={3}
                display="flex"
                flexDir="row"
                position="absolute"
                left={sidebarOpen ? '320px' : '10px'}
                transition="left 0.2s, top 0.2s, height 0.2s"
                top={topVal}
                width="40px"
                height={sidebarOpen ? '100%' : '160px'}
                borderRadius={sidebarOpen ? '0px' : '4px'}
                overflow="hidden"
                boxShadow={!sidebarOpen && '0px 0px 0px 2px rgba(0,0,0,0.1)'}
                borderLeft={sidebarOpen && '1px solid rgba(0,0,0,0.1)'}
                // borderRight={sidebarOpen && '1px solid rgba(0,0,0,0.1)'}
                // borderBottomRightRadius="2px"
            >
                <Box flex="0 0 auto" w="40px" mt={sidebarOpen ? '0px' : '0px'} transition="margin-top 0.2s">
                    {sidebarOpen ? (
                        <Tooltip placement="right" label={<Text>Close Menu</Text>}>
                            <Button
                                mt={`calc(${insets.top} - 2px)`}
                                _hover={{
                                    color: 'rgba(0,0,0,1.0)',
                                }}
                                bg={''}
                                w="40px"
                                h={'40px'}
                                onClick={() => {
                                    history.push('/' + history.location.search);
                                }}
                                color={'rgba(0,0,0,0.8)'}
                                borderBottom="1px solid rgba(0,0,0,0.1)"
                            >
                                <Text mb="0px">
                                    <Icon icon={sidebarOpen ? 'cross' : 'chevron-right'} size="16" />
                                </Text>
                            </Button>
                        </Tooltip>
                    ) : (
                        <Tooltip placement="right" label={<HStack align="center" justify="center" spacing={1}>
                            <Icon size='12' icon="arrow-top-left"></Icon>
                            <Text transform="translateY(-1px)" mb="0px">vectorcharts.com</Text>
                            </HStack>}>
                        <Box
                            w="40px"
                            h="40px"
                            zIndex={2}
                            display="flex"
                            flexDir="row"
                            justifyContent="center"
                            alignItems="center"
                            cursor="pointer"
                            bg="rgba(245,245,245,1.0)"
                            borderBottom="1px solid rgba(0,0,0,0.1)"
                            onClick={() => {
                                window.open(landingPageUrl, '_blank').focus();
                            }}
                        >
                            <Image opacity="0.9" src="/img/logo-v1.svg" w="20px"></Image>
                        </Box>
                        </Tooltip>
                    )}
                    <SidebarButton title="Map Settings" icon="map" path="/map" />
                    {/* <SidebarButton title="Destinations" icon="map-marker" path="/destinations" /> */}
                    <SidebarButton title="Routes" icon="route" path="/routes" />
                    {/* <SidebarButton title="Past Tracks" icon="timeline-events" path="/past-tracks" /> */}
                    <SidebarButton title="Search" icon="search" path="/search" />
                    {/* <Box h="1px" w="100%" mb="0px" bg="rgba(0,0,0,0.15)"></Box> */}
                </Box>
            </Box>

            <Box
                w="2px"
                h="100%"
                position="absolute"
                top="0px"
                left={sidebarOpen ? '360px' : '-10px'}
                transition="left 0.2s"
                zIndex={3}
                bg="rgba(0,0,0,0.05)"
            ></Box>
            <Box
                color="black"
                w={isDefaultRoute ? '0px' : '320px'}
                opacity={sidebarOpen ? 1.0 : 0.75}
                transition="width 0.2s, opacity 0.2s"
                position="absolute"
                top="0px"
                bottom="0px"
                height="100%"
                left="0px"
                zIndex={3}
                bg="rgba(255,255,255,0.9)"
                overflow="hidden"
                display="flex"
                flexDir="row"
            >
                {/* <Box w="40px" h="100%"></Box> */}
                <Box overflow="hidden" flex="0 0 auto" w="320px" display="flex" flexDir="column" justifyContent="stretch" alignItems="stretch">
                    <Box w="100%" h={insets.top}></Box> 
                    <Box height="40px" borderBottom="1px solid rgba(0,0,0,0.1)" flex="0 0 auto" padding="10px">
                        <Text fontWeight="500">
                            <Switch>
                                <Route path="/map">Map Settings</Route>
                                <Route path="/search">Search</Route>
                                <Route path="/routes">Routes</Route>
                                <Route path="/destinations">Destinations</Route>
                                <Route path="/past-tracks">Past Tracks</Route>
                            </Switch>
                        </Text>
                        {/* <Button
                            position="absolute"
                            top="0px"
                            right="0px"
                            onClick={() => {
                                history.push('/');
                            }}
                            color="rgba(0,0,0,0.8)"
                            variant="text"
                        >
                            <Icon icon="cross"></Icon>
                        </Button> */}
                    </Box>
                    <Box padding="0px" overflowX="hidden" overflowY="auto" w="100%" h="calc(100% - 50px)" display="flex" flexDir="column" justifyContent="stretch" alignItems="stretch">
                        <Switch>
                            <Route path="/map">
                                <MapSettings />
                            </Route>
                            <Route path="/search">
                                <MapSearch />
                            </Route>
                            <Route path="/routes">
                                <RouteEditor></RouteEditor>
                            </Route>
                            <Route path="/past-tracks">
                                <ZeroState
                                    title="No Past Tracks"
                                    icon="warning-sign"
                                    description="Past Tracks are unavailable."
                                ></ZeroState>
                            </Route>
                            <Route path="/destinations">
                                {markers.length == 0 ? (
                                    <ZeroState
                                        title="No Destinations"
                                        icon="map-marker"
                                        description="To create a destination, right-click at a point of interest and select Add Destination Here."
                                    ></ZeroState>
                                ) : (
                                    <VStack>
                                        {markers.map((marker) => {
                                            return (
                                                <Box
                                                    w="100%"
                                                    bg="white"
                                                    border="1px solid rgba(0,0,0,0.1)"
                                                    p="4px"
                                                    pl="10px"
                                                    pr="10px"
                                                    display="flex"
                                                    flexDir="column"
                                                    borderRadius="3px"
                                                    cursor="pointer"
                                                    onClick={() => {
                                                        mapRef.current.flyTo({
                                                            center: [marker.longitude, marker.latitude],
                                                            zoom: 9,
                                                        });
                                                    }}
                                                >
                                                    <Text fontWeight="500">{marker.name}</Text>
                                                    <Text>
                                                        {marker.latitude.toFixed(6)}, {marker.longitude.toFixed(6)}
                                                    </Text>
                                                </Box>
                                            );
                                        })}
                                    </VStack>
                                )}
                            </Route>
                        </Switch>
                    </Box>
                </Box>
            </Box>
        </>
    );
}
